export default __webpack_public_path__ + "assets/010da4ce24d6ce760b27323238290f75.png";